import io from 'socket.io-client';

const socket = io('https://admin.ishcallsign.com');
// const socket = io('http://localhost:12500');

export default socket;